import axios from 'axios';
import { GET_ERRORS , GET_BACKLOG,GET_PROJECT_TASK , DELETE_PROJECT_TASK}  from "./types";
export const addProjectTask = (backlog_id,project_task,history) => async dispatch=>{
    try{
    await axios.post("/api/backlog/"+backlog_id,project_task);
    history.push("/projectBoard/"+backlog_id);
    dispatch({
        type: GET_ERRORS,
        payload: {}
      });
    } catch (err) {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    }
}

export const getBacklog = backlog_id  => async dispatch=>{
  try{
    
    const res = await axios.get("/api/backlog/"+backlog_id);
  
    dispatch({
      type: GET_BACKLOG,
      payload: res.data
    });
  }catch(err){
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
     
  }
}
export const getProjectTask = (backlog_id,id, history) => async dispatch => {
  try {
    const res = await axios.get(`/api/backlog/${backlog_id}/${id}`);
    dispatch({
      type: GET_PROJECT_TASK,
      payload: res.data
    });
  } catch (error) {
    console.log(error);
    history.push(`/projectBoard/${backlog_id}`);
  }
};
export const deleteTask = sequence => async dispatch => {
  if (
    window.confirm(
      "Are you sure? This will delete the project and all the data related to it"
    )
  ) {
    await axios.delete(`/api/backlog/${sequence}`);
    dispatch({
      type: DELETE_PROJECT_TASK,
      payload: sequence
    });
  }
};